var map = {
	"./goldcoin/task-detail-step-2.jpg": 62633,
	"./memetown/task-detail-step-2.jpg": 38167,
	"./reflection/task-detail-step-2.jpg": 28896,
	"./tapcoin/task-detail-step-2.jpg": 50133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76451;